import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import styled from 'styled-components'
import { withTranslation } from 'react-i18next'
import { rhythm, media, color } from '../utils/typography'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTwitter } from '@fortawesome/free-brands-svg-icons'
import { faEnvelope } from '@fortawesome/free-solid-svg-icons'

import Container from './container'
import Link from './link'
import LanguageSwitcher from './language-switcher'
import External from './external'

export default styled(withTranslation()(({ className, t }) => {
  const { site: { siteMetadata: config } } = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          twitter
          email
        }
      }
    }
  `)
  return (
    <footer className={className}>
      <Container className='container'>
        <p className='brand'>
          <Link to='/'>{t('brand')}</Link>
        </p>

        <ul className='inline-list links'>
          <li><Link to='/extradition'>{t('extradition.link')}</Link></li>
          <li><Link to='/extradition/map'>{t('extradition.map.link')}</Link></li>
          <li><Link to='/nsl-statement'>{t('nsl.link')}</Link></li>
        </ul>

        <ul className='inline-list contact'>
          <li><External href={`https://twitter.com/${config.twitter.substring(1)}`}>
            <FontAwesomeIcon icon={faTwitter} />{' '}{config.twitter}
          </External></li>
          <li><a href={`mailto:${config.email}`}>
            <FontAwesomeIcon icon={faEnvelope} />{' '}{config.email}
          </a></li>
          <li><LanguageSwitcher className='switcher' /></li>
        </ul>
      </Container>
    </footer>
  )
}))`
  padding: ${rhythm(1/2)} 0;
  ${media.tablet} { padding: ${rhythm(1/2)} 0; }
  ${media.desktop} { padding: ${rhythm(1)} 0; }

  text-align: center;

  .brand, .links {
    margin: 0;
    margin-bottom: ${rhythm(1/2)};
  }

  .brand {
    font-size: 1.2em;
    font-weight: bold;
    a {
      &, &:visited {
        color: ${color.body};
      }
      &:hover, &:focus, &:active {
        color: ${color.accent};
      }
    }
  }
`
